import { Component, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';


@Component({
  selector: 'app-reproductie-embriotransfer',
  templateUrl: './reproductie-embriotransfer.component.html',
  styleUrls: ['./reproductie-embriotransfer.component.scss']
})
export class ReproductieEmbriotransferComponent {
  @Input() monta;
  @Input() form: UntypedFormGroup;
  @Input() field_errors;

  disabledFields = {};
  exploatatieID;
  listaTauri;
  listaFemelePurtatoare;
  listaFemeleDonatoare;

  constructor(
    private helperDataService: HelperDataService,
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes) {
    if (changes.monta && this.monta) {
      this.buildForm(this.monta);
    }
  }

  buildForm(formData?) {
    if (!formData) {
      formData = {};
    }

    this.form.addControl('data_insamantare', new UntypedFormControl(formData['data_insamantare']));
    this.form.addControl('nr_document', new UntypedFormControl(formData['nr_document']));
    this.form.addControl('file_name', new UntypedFormControl(formData['file_name']));
    this.form.addControl('file_id', new UntypedFormControl(formData['file_id']));
    this.form.addControl('taur_id', new UntypedFormControl(formData['taur_id']));
    this.form.addControl('rasa_id', new UntypedFormControl(formData['rasa_id']));
    this.form.addControl('femela_donatoare_id', new UntypedFormControl(formData['femela_donatoare_id']));
    this.form.addControl('femela_purtatoare_id', new UntypedFormControl(formData['femela_purtatoare_id']));

    this.exploatatieID = this.form.value.exploatatie_id || formData['exploatatie_id'];
    this.listaTauri = formData['lista_tauri'];
    this.listaFemelePurtatoare = formData['lista_femele_purtatoare'];
    this.listaFemeleDonatoare = formData['lista_femele_donatoare'];
    this.disabledFields = formData['disabled_fields'] || {};
    this.field_errors = {};
  }

  dataMontaChange(event) {
    this.form.controls.data_insamantare.setValue(event);
    this.field_errors['data_insamantare'] = null;
  }

  selectTaur(event) {
    let rasaID = event ? event['rasa_id'] : null;
    this.form.controls.rasa_id.setValue(rasaID);
    this.field_errors['taur_id'] = null;
  }

  selectFemelaDonatoare() {
    this.field_errors['femela_donatoare_id'] = null;
  }

  selectFemelaPurtatoare() {
    this.field_errors['femela_purtatoare_id'] = null;
  }

  searchTaur(event) {
    if (event.term.length < 4) {
      this.listaTauri = [];
      return;
    }

    let req_params = {
      numarmatricol: event.term,
      sex: 1,
    };

    this.helperDataService.getAnimals(req_params)
      .subscribe((response: any) => {
        this.listaTauri = response.result;
      });
  }

  searchFemelaPurtatoare(event) {
    if (event.term.length < 4) {
      this.listaFemelePurtatoare = [];
      return;
    }

    let req_params = {
      numarmatricol: event.term,
      sex: 2,
      status: 1,
      companyid: this.exploatatieID,
    };

    this.helperDataService.getAnimals(req_params)
      .subscribe((response: any) => {
        this.listaFemelePurtatoare = response.result;
      });
  }

  searchFemelaDonatoare(event) {
    if (event.term.length < 4) {
      this.listaFemeleDonatoare = [];
      return;
    }

    let req_params = {
      numarmatricol: event.term,
      sex: 2,
      rasa_id: this.form.value.rasa_id,
    };

    this.helperDataService.getAnimals(req_params)
      .subscribe((response: any) => {
        this.listaFemeleDonatoare = response.result;
      });
  }

  uploadInsamantareArtificiala(event) {
    if (event.body && event.body.files) {
      const file = event.body.files[0];
      this.form.controls.file_id.setValue(file.file_id);
      this.form.controls.file_name.setValue(file.file_uploaded_name);
      this.field_errors['file_id'] = null;
    }
  }

  downloadFile(event) {
    event.target.disabled = true;
    const fileId = this.form.value.file_id;
    const fileName = this.form.value.file_name;

    if (!fileId) {
      return;
    }

    this.helperDataService.downloadFile(fileId)
      .subscribe((response: any) => {
        const blob = new Blob([response]);
        this.helperDataService.simulateDownload(blob, fileName);
        event.target.disabled = false;
      });
  }

  deleteFile() {
    this.form.controls.file_id.reset();
    this.form.controls.file_name.reset();
  }
}
